// extracted by mini-css-extract-plugin
export default {"container":"tareas_container__O8d+0","children":"tareas_children__1cT95","btnX":"tareas_btnX__bzLQn"};